import { Divider } from "~/components/Divider";
import { LoginButton } from "~/components/LoginButton";
import { Body, Button, Card, Headline, Icon } from "~/ui-library";
import { ArrowLeftIcon } from "~/ui-library/icons";

export type SubCheckoutCreateYourAccountVerifyProps = {
  onBackClick?: () => void;
  /** email address that was sent a confirmation email  */
  email: string;
};

export const SubCheckoutCreateYourAccountVerify: React.FC<
  SubCheckoutCreateYourAccountVerifyProps
> = ({ onBackClick, email }) => (
  <Card className="px-m py-s" elevation={0}>
    <Button
      className="mb-s"
      data-testid="back-button"
      onClick={onBackClick}
      size="extraSmall"
      variant="link"
    >
      <Icon className="mr-xxs" size="small" SvgIcon={ArrowLeftIcon} />
      Back
    </Button>

    <Body bold className="mb-xs text-gray-700" size="small">
      Finish Creating Your Account
    </Body>

    <Headline level={4} className="mb-m">
      Verify Your Email Address
    </Headline>

    <Body size="small" className="mb-xxs md:mb-0">
      We sent an email to <span className="text-gray-700">{email}</span>. Follow
      the instructions in the email to finish creating up your account.
    </Body>

    <Divider containerClassName="my-m" />

    <Body size="small" className="mb-m text-gray-900">
      Already verified your email? Sign in to continue checking out.{" "}
    </Body>

    <LoginButton
      behavior={{
        type: "window",
      }}
    >
      Sign in
    </LoginButton>
  </Card>
);
